import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92489 23 12C23 12.9902 22.8692 13.9498 22.6239 14.8626C21.6561 14.0142 20.3881 13.5 19 13.5C15.9624 13.5 13.5 15.9624 13.5 19C13.5 20.3881 14.0142 21.6561 14.8626 22.6239C13.9499 22.8692 12.9902 23.0001 12 23.0001C5.92486 23.0001 1 18.0752 1 12C1 5.92489 5.92486 1 12 1ZM16.8028 11.9999L9.5 7.13135V16.8684L16.8028 11.9999Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z"}}]};

const PlayCircleStrokeAddFilled = Vue.extend<IconProps>({
  name: 'PlayCircleStrokeAddFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'play-circle-stroke-add-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PlayCircleStrokeAddFilled;
